import React, { useState, useEffect, useMemo } from "react";
import {Dialog as FluentDialog, Text, Button, Input, Form, FormInput, Loader,  EditIcon,  TrashCanIcon, Checkbox,  Datepicker, Card,
  CardBody, CardHeader, FormDropdown, Dropdown, Label,TextArea } from "@fluentui/react-northstar";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { AddIcon, SearchIcon, CloseIcon } from "@fluentui/react-icons-northstar";
import { WindowContext } from "../../shared/contexts/Context";
import { process } from "@progress/kendo-data-query";
import { OPERATIONSTATUS } from '../../shared/appcomponents/enums';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import debounce from 'lodash.debounce';
import { RenderTooltipCell } from "../../shared/appcomponents/TooltipWithCopy";
import SettingsService from "../../services/settingsservice";
import { CellDateTime} from '../../../components/shared/appcomponents/custom-grid-cells';
import { NativeTimePicker, TeamsDatePicker, TeamsTimePicker, TimeList } from '../../../components/shared/appcomponents/custom-datetime-inputs';

const SettingsCustomizedAlert = (props) => {
  const [alerts, setAlerts] = useState([]);
  const [alertData, setAlertData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isHeadingValid, setIsHeadingValid] = useState(true);
  const [isQueryValid, setIsQueryValid] = useState(true);
  const [isEmailIdsValid, setIsEmailIdsValid] = useState(true);
  const [isInstanceValid, setisInstanceValid] = useState(true);
  const [openDeleteConfirmationDialog, setDeleteConfirmationDialog] = useState(false);
  const [deleteAlertObj, setDeleteAlertObj] = useState(null);
  const [alertTypes, setalertTypes] = React.useState(null);
  const [selectedAlertType, setselectedAlertType] = React.useState({ header: 'Hourly', value: 'Hourly', key: 1 });
  const [selectedInstance, setselectedInstance] = React.useState(null);
  const [selectedUser, setselectedUser] = React.useState(null);
  const [instances, setinstances] = React.useState(null);
  const [users, setusers] = React.useState(null);
  const [dataState, setDataState] = useState({
    sort: [{ field: "Id", dir: "asc" }],
    take: 10,
    skip: 0,
    filter: {
      logic: "or",
      filters: [],
    },
  });
  const [isSaving, setIsSaving] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [newAlertData, setNewAlertData] = useState({
    TaskTypeId: "",
    Heading: "",
    InstanceId: "",
    Query: "",
    EmailIds: "",
    NextRunTime: new Date(),
    IsActive: false,
  });

  useEffect(() => {
    props.acquireToken(authSuccessCallback);
  }, []);

  const authSuccessCallback = (token) => {
    if (token) {
      SettingsService.GetCustomisedAlerts(token).then((response) => {
        if (response && response.status === 200) {
          setAlerts(response.data);
          setIsLoaded(true);
          setDataState({ ...dataState, data: response.data });

          SettingsService.GetMasterCustomisedAlertsData(token).then(
            (response) => {
              if (response && response.status == 200) {
                response = response.data;
                setalertTypes(response.CustomAlertTypes);
                setinstances(response.InstanceNames);
                setusers(response.AppUsers);
              }
            }
          );

        } else {
          props.viewStatus.InformChildPageStatus(response.status || 500);
          setIsLoaded(true);
        }
      });
    }
  };

  const filterGridData = (value) => {
    let filter = {
      logic: "or",
      filters: [
        { field: "Id", operator: "contains", value: value },
        { field: "Heading", operator: "contains", value: value },
        { field: "Query", operator: "contains", value: value },
        { field: "EmailIds", operator: "contains", value: value },
      ],
    };
    setDataState({ ...dataState, filter: filter });
  };

  const handleAddEditClickOpen = (dataItem, isEdit) => {
    setIsHeadingValid(true);
    setIsQueryValid(true);
    setIsEmailIdsValid(true);
    setVisible(true);
    setisInstanceValid(true);
    setIsSaving(false);

    if (isEdit === true) {
      
      setAlertData(dataItem);

      if(alertTypes && alertTypes.length > 0){
        let at = alertTypes.filter(obj => {
          return obj.Id === dataItem.TaskTypeId
        });

        if(at && at.length > 0){
          setselectedAlertType({ header: at[0].TaskType, value: at[0].TaskType, key: at[0].Id });
        }
      }

      if(instances && instances.length > 0){
        let ins = instances.filter(obj => {
          return obj.InstanceId === dataItem.InstanceId
        });

        if(ins && ins.length > 0){
          setselectedInstance({ header: ins[0].InstanceName, value: ins[0].InstanceName, key: ins[0].InstanceId });
        }
      }

      debugger
      if(users && users.length > 0 && dataItem.EmailIds && dataItem.EmailIds.length > 0){
        let arr = dataItem.EmailIds.split(',') ;
        // let sel_users = users.filter(obj => {
        //   return arr.some(s => s === obj.value)
        // });

        if(arr && arr.length > 0){
          let arr_users = [null];

          for(let i = 0 ; i < arr.length; i++){
            let sel = users.filter(obj => {
              if(obj && obj.value && obj.value.length > 0 && arr[i] && arr[i].length > 0){
                return obj.value.toLowerCase() === arr[i].toLowerCase()
              }
            });

            if(sel && sel.length > 0){
              arr_users.push({header: sel[0].header, value: arr[i], key: arr[i]})
            }
          }
          setselectedUser(arr_users);
        }
      }
      // console.log(alertTypes);
      setEditMode(true);
    } 
    else {
      setAlertData({
        Id: 0,
        TaskTypeId: "",
        Heading: "",
        InstanceId: "",
        Query: "",
        EmailIds: "",
        NextRunTime: new Date(),
        IsActive: false,
        IsTimeSet : false,
        StartTime : "00:00",
        EndTime : "00:00"
      });
      setselectedInstance(null);
      setEditMode(false);
      setAlertData({ ...alertData, IsActive: true, StartTime: "00:00",  EndTime : "00:00"});
      setselectedAlertType({ header: 'Hourly', value: 'Hourly', key: 1 });
      let usersSelected = [null];
      setselectedUser(null);
    }
  };

  const handleAddEditClickClose = () => {
    setVisible(false);
    setAlertData(null);
    setEditMode(false);
    setIsHeadingValid(true);
    setIsQueryValid(true);
    setIsEmailIdsValid(true);
  };

  const handleDeleteClickOpen = (dataItem) => {
    setDeleteAlertObj(dataItem);
    setDeleteConfirmationDialog(true);
  };

  const handleDeleteClose = () => {
    setDeleteConfirmationDialog(false);
    setDeleteAlertObj(null);
  };

  const handleSave = () => {
    debugger
    let isValid = true;

    

    alertData.TaskTypeId = selectedAlertType.key;
    
    if (!alertData.Heading) {
      setIsHeadingValid(false);
      isValid = false;
    } else {
      setIsHeadingValid(true);
    }

    if (!alertData.Query) {
      setIsQueryValid(false);
      isValid = false;
    } else {
      setIsQueryValid(true);
    }

    // if (!alertData.EmailIds) {
    //   setIsEmailIdsValid(false);
    //   isValid = false;
    // } else {
    //   setIsEmailIdsValid(true);
    // }

    if (selectedInstance && selectedInstance.key > 0) {
      setisInstanceValid(true);
      alertData.InstanceId = selectedInstance.key;
    } else {
      setisInstanceValid(false);
      isValid = false;
    }
    
    if (selectedUser && selectedUser.length > 1) {
      setIsEmailIdsValid(true);
      let ids = '';
      for(let i=0; i< selectedUser.length; i++){
        let u = selectedUser[i];
        if(u && u.value && u.value.length > 0){
          ids +=  u.value + "," ;
        }
      }
      alertData.EmailIds = ids.replace(/,\s*$/, "");

      // alertData.InstanceId = selectedInstance.key;
    } else {
      setIsEmailIdsValid(false);
      isValid = false;
    }

    if (!isValid) return;
    
    if (isSaving === true){
      return;
    } 

    debugger
    if((alertData.IsTimeSet && alertData.IsTimeSet === true)){
      if (editMode === true)  {
        if(!(alertData.StartTime && alertData.StartTime.length > 0)){
          alertData.StartTime = "00:00";
        }

        if(!(alertData.EndTime && alertData.EndTime.length > 0)){
          alertData.EndTime = "00:00";
        }
      }
    }
    else{
      alertData.StartTime = null;
      alertData.EndTime = null;
    }
    setIsSaving(true);
    props.acquireToken((token) => {

      if(editMode ===  true){
        SettingsService.UpdateCustomisedAlert(alertData, token).then((response) => {
          if (response && response.status === 200) {
            authSuccessCallback(token);
            handleAddEditClickClose();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
          // setIsSaving(false);
        }).finally(() => {
          setIsSaving(false);
        });
      }
      else{
        SettingsService.AddCustomisedAlert(alertData, token).then((response) => {
          if (response && response.status === 200) {
            authSuccessCallback(token);
            handleAddEditClickClose();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
          // setIsSaving(false);
        }).finally(() => {
          setIsSaving(false);
        });
      }
      // const serviceCall = editMode ? SettingsService.UpdateCustomisedAlert(alertData, token)  : SettingsService.AddCustomisedAlert(alertData, token);
      // serviceCall.then((response) => {
      //   if (response && response.status === 200) {
      //     authSuccessCallback(token);
      //     handleAddEditClickClose();
      //     props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
      //   } else {
      //     props.viewStatus.DisplayOperationStatus(response.status || 500);
      //   }
      //   setIsSaving(false);
      // }).catch(() => {
      //   setIsSaving(false);
      // });
    });
  };

  const handleDelete = () => {
    const updatedAlerts = alerts.filter(alert => alert.Id !== deleteAlertObj.Id);
    setAlerts(updatedAlerts);

    props.acquireToken((token) => {
      SettingsService.DeleteCustomisedAlert(deleteAlertObj.Id, token)
        .then((response) => {
          if (response && response.status === 200) {
            setDataState({ ...dataState, data: updatedAlerts });
            handleDeleteClose();
            props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
          } else {
            setAlerts(alerts);
            props.viewStatus.DisplayOperationStatus(response.status || 500);
          }
        })
        .catch(() => {
          setAlerts(alerts);
        });
    });
  };

  const processedData = useMemo(() => process(alerts, dataState), [alerts, dataState]);

  const handleToggleChange = (dataItem) => {
    const updatedAlert = { ...dataItem, IsActive: !dataItem.IsActive };
    props.acquireToken((token) => {
      SettingsService.UpdateCustomisedAlert(updatedAlert, token).then((response) => {
        if (response && response.status === 200) {
          authSuccessCallback(token);
          props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
        } else {
          props.viewStatus.DisplayOperationStatus(response.status || 500);
        }
      });
    });
  };

  const handleDateChange = (e, data) => {
    const localDate = new Date(data.value);
    setAlertData({ ...alertData, NextRunTime: localDate });
  };

  const handleAlertTypeChange = (_selectedType) => {
    
		setselectedAlertType(_selectedType);
	}

  const handleInstanceChange = (_selectedType) => {
		setselectedInstance(_selectedType);
	}

  const handleUserChange = (_selectedType) => {
		setselectedUser(_selectedType);
	}

  const handleStartTimeChange = (e, data) => {
		setAlertData({ ...alertData, StartTime: data.value })
	};

  const handleEndTimeChange = (e, data) => {
		setAlertData({ ...alertData, EndTime: data.value })
	};


  const handleSaveDebounced = debounce(handleSave, 300);

  return isLoaded ? (
    <WindowContext.Consumer>
      {(context) => (
        <div className="row h-100">
          <div className="col-md-12 h-100">
            <Card className="card-border bg-white h-100" fluid>
              <CardHeader className="mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="f-size-18">Customized Alerts</div>
                    {props.user?.Permissions?.some((p) => (p == "Settings.ReadWrite" || p == "Settings.Configuration.ReadWrite")) &&
                      <Button
                        icon={<AddIcon />}
                        iconPosition="before"
                        content="New Alert"
                        primary
                        title="Add Customised Alert"
                        onClick={handleAddEditClickOpen} className="ml-auto"
                      />}
                </div>
              </CardHeader>
              <CardBody>
               
                <div className="tbl-search float-right text-right mb-2">
                  <Input
                    onChange={(e) => filterGridData(e.target.value)}
                    inverted
                    icon={<SearchIcon />}
                    placeholder="Search..."
                    className="border-gray"
                  />
                </div>
                <div className="grid-with-search">
                  <Grid
                    style={{
                      height: "100%",
                    }}
                    pageable={{
                      buttonCount: 3,
                    }}
                    sortable={true}
                    data={processedData.data}
                    total={processedData.total}
                    skip={dataState.skip}
                    take={dataState.take}
                    sort={dataState.sort}
                    onDataStateChange={(e) => {
                      setDataState(e.dataState);
                    }}
                  >
                    <Column field="Heading" title="Name" width="150px"  />
                    <Column field="Query" title="Query" width="200px"  />
                    <Column field="EmailIds" title="Email IDs" width="200px"  />
                    <Column field="NextRunTime" title="Next Run Time UTC" width="150px" cell={CellDateTime}  />
                    <Column field="IsActive" title="Active" width="80px"
                      cell={(props) => (
                        <td style={{ textAlign: "center" }}>
                          <Checkbox
                            toggle
                            checked={props.dataItem.IsActive}
                            onChange={() => handleToggleChange(props.dataItem)}
                          />
                        </td>
                      )}
                    />
                    {props.user?.Permissions?.some((p) => p === "Settings.Read" || p === "Settings.ReadWrite" || p === "Settings.Configuration.ReadWrite") && (
                      <Column
                        field=""
                        title="Actions"
                        style={{ textAlign: "center" }}
                        width={100}
                        cell={(props) => (
                          <td style={{ textAlign: "center" }}>
                            <Button
                              styles={{ height: 'auto' }}
                              iconOnly
                              size="small"
                              icon={<EditIcon />}
                              text
                              onClick={() => handleAddEditClickOpen(props.dataItem, true)}
                            />
                            <Button
                              styles={{ height: 'auto' }}
                              iconOnly
                              size="small"
                              icon={<TrashCanIcon />}
                              text
                              onClick={() => handleDeleteClickOpen(props.dataItem)}
                            />
                          </td>
                        )}
                      />
                    )}
                  </Grid>
                </div>
              </CardBody>
            </Card>
          </div>
          <div>
            {visible && (
              <Dialog
                className="k-dialog-md custom-alert"
                title={editMode ? "Edit Alert" : "Add Alert"}
                onClose={handleAddEditClickClose}
              >
                <Form>
                  <div className='row mb-0'>
                    <div className='col-12 col-md-6 mb-3'>
                      <FormInput
                        label={isHeadingValid ? "Name*" : <Text color="red" content="Name* - Required" />}
                        className="custom-alert-name"
                        id="heading-inline"
                        fluid
                        value={alertData?.Heading || ""}
                        onChange={(e) => {
                          setAlertData({ ...alertData, Heading: e.target.value });
                          setIsHeadingValid(e.target.value !== "");
                        }}
                        error={!isHeadingValid}
                        // placeholder="Alert Heading"
                      />
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                        <div style={{ marginBottom: "3px" }} >Select Email Time*</div>
                        <Dropdown className="custom-alert-type"
                          label={{
                            content: `Alert Type Name`
                          }}
                          items={alertTypes?.map((obj) => {
                            return { header: obj.TaskType, value: obj.TaskType, key: obj.Id };
                          })}
                          placeholder="Select Interval"
                          fluid
                          value={selectedAlertType}
                          onChange={(e, selectedItem) => {
                            handleAlertTypeChange(selectedItem.value);
                          }}
                          // onChange={handlePlatformChange}
                        />
                    </div>
                  </div>

                  <div>
                    <Checkbox className="custom-alert-timeChk"
                      toggle
                      checked={alertData?.IsTimeSet || false}
                      onChange={(e, data) => setAlertData({ ...alertData, IsTimeSet: data.checked })}
                    />
                    <label style={{ display: "inline" }}>Time Enabled</label>
                  </div>
                  <div className='row mb-0 custom-alert-time'>
                    <div className='col-12 col-md-6 mb-3'>
                      <div style={{marginBottom: "2px"}} >Email Start Time</div>
                      <div className="time-ddl-container">
													<Dropdown 
														items={TimeList? TimeList.map(m => m.header) : null}
														onChange={handleStartTimeChange}
														className="time-ddl"
														value={alertData?.StartTime ? alertData?.StartTime :"00:00"}
														disabled={alertData?.IsTimeSet ? !alertData?.IsTimeSet : true}
													/>
                      </div>	
                    </div>
                    <div className='col-12 col-md-6 mb-3'>
                      <div style={{marginBottom: "2px"}} >Email End Time</div>
                      <div className="time-ddl-container">
													<Dropdown 
														items={TimeList? TimeList.map(m => m.header) : null}
														onChange={handleEndTimeChange}
														className="time-ddl"
														value={alertData?.EndTime ? alertData?.EndTime :"00:00"}
														disabled={selectedAlertType.key === 3 ? true : alertData?.IsTimeSet ? !alertData?.IsTimeSet : true}
													/>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div style={{ marginBottom: "3px" }} >{isInstanceValid ? "Instance*" : <Text color="red" content="Instance* - Required" />}</div>
                    <Dropdown className="custom-instances"
                      label={{
                        content: `Instances`
                      }}

                      items={instances?.map((obj) => {
                        return { header: obj.InstanceName, value: obj.InstanceName, key: obj.InstanceId };
                      })}
                      placeholder="Select Instance"
                      fluid
                      value={selectedInstance}
                      onChange={(e, selectedItem) => {
                        handleInstanceChange(selectedItem.value);
                        debugger
                        if(selectedItem && selectedItem.value && selectedItem.value.key > 0){
                          setisInstanceValid(true);
                        }
                        else{
                          setisInstanceValid(false);
                        }
                      }}
                      // onChange={handlePlatformChange}
                    />
                  </div>

                  <div style={{ marginBottom: "3px" }} >{isQueryValid ? "Query*" : <Text color="red" content="Query* - Required" />}</div>
                  <TextArea 
                    label={isQueryValid ? "Query" : <Text color="red" content="Query* - Required" />}
                    style={{ height: "70px"}} className="custom-alert-query"
                    id="query-inline"
                    fluid
                    value={alertData?.Query || ""}
                    onChange={(e) => {
                      setAlertData({ ...alertData, Query: e.target.value });
                      setIsQueryValid(e.target.value !== "");
                    }}
                    error={!isQueryValid}
                    // placeholder="SELECT * FROM..."
                  />

                  <div style={{ marginBottom: "3px" }} >{isEmailIdsValid ? "Email To*" : <Text color="red" content="Email To* - Required" />}</div>

                  <Dropdown className="custom-alert-email"
                      label={{
                        content: `Users`
                      }}
                      multiple
                      items={users?.map((obj) => {
                        return { header: obj.header, value: obj.value, key: obj.value };
                      })}
                      // placeholder="Select Users"
                      fluid
                      value={selectedUser}
                      onChange={(e, selectedItem) => {
                        handleUserChange(selectedItem.value);
                        
                        if(selectedItem && selectedItem.value && selectedItem.value.length > 1){
                          setIsEmailIdsValid(true);
                        }
                        else{
                          setIsEmailIdsValid(false);
                        }
                      }}
                      // onChange={handlePlatformChange}
                    />

                  {/* <FormInput
                    label={isEmailIdsValid ? "Email IDs*" : <Text color="red" content="Email IDs* - Required" />}
                    className="custom-alert-email"
                    id="emailIds-inline"
                    fluid
                    value={alertData?.EmailIds || ""}
                    onChange={(e) => {
                      setAlertData({ ...alertData, EmailIds: e.target.value });
                      setIsEmailIdsValid(e.target.value !== "");
                    }}
                    error={!isEmailIdsValid}
                    // placeholder="email1@example.com, email2@example.com"
                  /> */}
                  {/* <div>
                    <label>Next Run Time</label>
                    <Datepicker
                      label="Next Run Time"
                      value={alertData?.NextRunTime || new Date()}
                      onDateChange={handleDateChange}
                    />
                  </div> */}
                  <div>
                    <Checkbox className="custom-alert-isActive"
                      toggle
                      checked={alertData?.IsActive || false}
                      onChange={(e, data) => setAlertData({ ...alertData, IsActive: data.checked })}
                    />
                    <label style={{ display: "inline" }}>Enabled</label>

                  </div>
                  
                  <div className="custom-alert-action">
                    <DialogActionsBar  layout="end">
                      <Button  onClick={handleAddEditClickClose}> Close </Button>
                      <Button  primary onClick={handleSaveDebounced}> Submit </Button>
                    </DialogActionsBar>
                  </div>
                  
                </Form>
              </Dialog>
            )}
          </div>
          <FluentDialog
            cancelButton="Cancel"
            confirmButton="Confirm"
            onCancel={handleDeleteClose}
            onConfirm={handleDelete}
            open={openDeleteConfirmationDialog}
            backdrop
            header="Confirm"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => {
                setDeleteConfirmationDialog(false);
                setDeleteAlertObj(null);
              },
            }}
            content={`Are you sure you want to delete the customised alert "${deleteAlertObj?.Heading}"?`}
          />
        </div>
      )}
    </WindowContext.Consumer>
  ) : (
    <Loader />
  );
};

export default SettingsCustomizedAlert;